import 'dayjs/locale/pt-br';
import useUserWelcomeCard from './use-user-welcome-card.hook';
import './user-welcome-card.styles.scss';
import { useTranslation } from 'react-i18next';

const UserWelcomeCard = () => {
  const { saudacao, username } = useUserWelcomeCard();
  const { t } = useTranslation(["instrutor"]);

  return (
    <div className="user-welcome-card">
      <h6 className="user-welcome-card__saudation">{saudacao}</h6>
      <div className="user-welcome-card__hello-name">
        <h2 className="hello-name__hello">{t('instrutor:hello')}</h2>
        <h2>{username}</h2>
      </div>
    </div>
  );
};

export default UserWelcomeCard;
